var map = {
	"./AIS_TH/images/branding-logo.svg": 4148,
	"./BNPPARIBAS_FR/images/branding-logo.svg": 2350,
	"./FRANK_FS_TH/images/branding-logo.svg": 3078,
	"./ORANGE_FR/images/branding-logo.svg": 911,
	"./RECONNECTS_HK/images/branding-logo.svg": 4060,
	"./UPLUS/images/branding-logo.svg": 5631,
	"./WINDTRE_IT/images/branding-logo.svg": 7576,
	"./bolttech/images/branding-logo.svg": 2818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1751;